/*
 * NuovaGlam™ Clear+ : cadeaux de l'offre selon le panier réel (23/10/2026), copie de assets/ng-lv-cart-sync.js (ceinture).
 * La ligne Clear+ porte _ng_cs_offer (x1 / x3 / x6) et _ng_cs_gifts = « variante:quantité[:fixe] » séparés par des virgules,
 *   écrits par sections/ng-cs-product.liquid. Les cadeaux (produits UNLISTED à 0 €) sont posés et retirés par le fetch d'une
 *   iframe vide (aucun AddToCart Meta en plus), propriété privée _ng_cs_gift + mention visible « Gift ».
 * Quantité : cadeau × quantité réelle de la ligne, sauf « fixe » (eBook = 1). Ligne Clear+ supprimée = cadeaux retirés.
 * Une seule requête après la native (cartData du tiroir, sections dans la mutation) — standard vitesse-page-panier.md.
 */
(() => {
  if (window.__ngCsCartSync) return;
  window.__ngCsCartSync = true;
  const GIFT_VARIANTS = [58973417341259, 58973417374027, 58973417406795];   /* patchs ×30, patchs ×60, eBook */
  const SOURCE = 'ng-cs-sync';
  const GIFT_KEY = 'Gift';
  const GIFT_VALUE = 'Included with your offer';
  const route = (path) => (window.Shopify?.routes?.root || '/') + path;
  const absolute = (path) => window.location.origin + route(path);
  let rawFetch = null;
  function cleanFetch() {
    if (rawFetch) return rawFetch;
    try {
      const frame = document.createElement('iframe');
      frame.hidden = true;
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      document.body.appendChild(frame);
      rawFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
    } catch (e) {
      rawFetch = window.fetch.bind(window);
    }
    return rawFetch;
  }

  function plan(cart) {
    const items = cart.items || [];
    const need = new Map();
    items.filter((i) => i.properties && i.properties._ng_cs_offer).forEach((line) => {
      String(line.properties._ng_cs_gifts || '').split(',').map((x) => x.trim()).filter(Boolean).forEach((spec) => {
        const [id, qty, fixed] = spec.split(':');
        const vid = Number(id);
        if (!vid) return;
        const q = fixed ? Number(qty) || 1 : (Number(qty) || 1) * line.quantity;
        need.set(vid, fixed ? Math.max(need.get(vid) || 0, q) : (need.get(vid) || 0) + q);
      });
    });
    const known = new Set(GIFT_VARIANTS.concat([...need.keys()]));
    const gifts = items.filter((i) => i.properties && i.properties._ng_cs_gift);
    const strays = items.filter((i) => known.has(i.variant_id) && !(i.properties && i.properties._ng_cs_gift));
    const updates = {};
    const have = new Map();
    gifts.forEach((g) => {
      const want = need.get(g.variant_id) || 0;
      if (have.has(g.variant_id) || want === 0) { updates[g.key] = 0; return; }
      have.set(g.variant_id, true);
      if (g.quantity !== want) updates[g.key] = want;
    });
    strays.forEach((g) => { updates[g.key] = 0; });
    if (Object.keys(updates).length) return { step: 'update', updates };
    const add = [...need.entries()].filter(([id, q]) => q > 0 && !have.has(id))
      .map(([id, q]) => ({ id, quantity: q, properties: { _ng_cs_gift: 'clear-plus', [GIFT_KEY]: GIFT_VALUE } }));
    return add.length ? { step: 'add', items: add } : null;
  }

  async function readCart() {
    const r = await fetch(route('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' });
    if (!r.ok) throw new Error(`cart ${r.status}`);
    return r.json();
  }
  function hostsToRender() {
    const hosts = ['cart-drawer-items', 'cart-items']
      .map((s) => document.querySelector(s))
      .filter((h) => h && typeof h.getSectionsToRender === 'function')
      .map((host) => ({ host, sections: host.getSectionsToRender() }));
    const drawer = document.querySelector('cart-drawer');
    if (!hosts.length && drawer && typeof drawer.getSectionsToRender === 'function') hosts.push({ host: drawer, sections: drawer.getSectionsToRender().map((s) => ({ id: s.id, section: s.section || s.id, selector: s.selector })) });
    return hosts;
  }
  const sectionIds = (hosts) => [...new Set(hosts.flatMap(({ sections }) => sections.map((s) => s.section)))];

  async function post(path, body) {
    const r = await cleanFetch()(absolute(path), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok || data.status) throw new Error(data.description || data.message || `${path} ${r.status}`);
    return data;
  }

  async function render(cart, given) {
    const hosts = hostsToRender();
    const drawer = document.querySelector('cart-drawer');
    if (!hosts.length) return;
    const ids = sectionIds(hosts);
    let html = given && ids.every((id) => typeof given[id] === 'string') ? given : null;
    if (!html) {
      const r = await fetch(`${route('cart')}?sections=${ids.join(',')}`, { credentials: 'same-origin', cache: 'no-store' });
      if (!r.ok) throw new Error(`sections ${r.status}`);
      html = await r.json();
    }
    const empty = cart.item_count === 0;
    hosts.forEach(({ host, sections }) => {
      host.classList.toggle('is-empty', empty);
      sections.forEach((s) => {
        const el = document.getElementById(s.id);
        if (!el || typeof html[s.section] !== 'string') return;
        const target = (s.selector && el.querySelector(s.selector)) || el;
        const markup = typeof host.getSectionInnerHTML === 'function'
          ? host.getSectionInnerHTML(html[s.section], s.selector)
          : new DOMParser().parseFromString(html[s.section], 'text/html').querySelector(s.selector || '.shopify-section')?.innerHTML;
        if (typeof markup === 'string') target.innerHTML = markup;
      });
    });
    drawer?.classList.toggle('is-empty', empty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
  }

  const isCart = (c) => c && Array.isArray(c.items) && typeof c.item_count === 'number';
  async function reconcile(given) {
    let cart = isCart(given) ? given : await readCart();
    let changed = false;
    let sections = null;
    const ids = sectionIds(hostsToRender());
    const extra = ids.length ? { sections: ids, sections_url: window.location.pathname } : {};
    for (let i = 0; i < 4; i += 1) {
      const next = plan(cart);
      if (!next) break;
      changed = true;
      if (next.step === 'update') {
        const data = await post('cart/update.js', Object.assign({ updates: next.updates }, extra));
        sections = data.sections || null;
        cart = data;
      } else {
        const data = await post('cart/add.js', Object.assign({ items: next.items }, extra));
        sections = data.sections || null;
        cart = await readCart();
      }
    }
    return changed ? { cart, sections } : null;
  }

  let queue = Promise.resolve();
  const run = (given) => {
    queue = queue.then(async () => {
      try {
        const done = await reconcile(given);
        if (done) {
          await render(done.cart, done.sections);
          document.dispatchEvent(new CustomEvent('ng-cs:cart-synced', { detail: { cart: done.cart } }));
        }
      } catch (e) {
        console.error('[NuovaGlam Clear+ cart sync]', e);
      }
    });
    return queue;
  };

  window.NuovaGlamClearCart = { plan, reconcile, run, idle: () => queue };
  const start = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { if (event?.source !== SOURCE) setTimeout(() => run(event && event.cartData), 0); });
    }
    run();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
